import { render, staticRenderFns } from "./HomeCategories.vue?vue&type=template&id=d44d8ab6"
import script from "./HomeCategories.vue?vue&type=script&lang=js"
export * from "./HomeCategories.vue?vue&type=script&lang=js"
import style0 from "./HomeCategories.vue?vue&type=style&index=0&id=d44d8ab6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports